import React from "react";
import { WIZARD_STEPS, stepState } from "./brandWizardSteps";

/**
 * The 1–5 trail across the top of the brand wizard.
 *
 * Every step is CLICKABLE — the owner can go straight to Promotion to fix a
 * typo without clicking Next four times, and back again. The parent decides
 * whether a jump is allowed (see brandWizardSteps#canLeaveStep) and reports
 * anything that needs fixing through `problemsByStep`, which puts a
 * "Verification needed" flag on the step that owns the problem. The flag shows
 * wherever the owner currently is, so a bad value on step 2 is visible from
 * step 5 rather than only when they happen to walk back past it.
 *
 * The connector lines are `::before`/`::after` on the `.step-0N` wrapper, so
 * the button goes INSIDE the wrapper rather than replacing it.
 */
export default function BrandWizardStepper({
  steps = WIZARD_STEPS,
  current,
  problemsByStep = {},
  onJump,
  images = {},
}) {
  return (
    <div className="stepper-div">
      {steps.map((s) => {
        const state = stepState(s.key, current);
        const problems = problemsByStep[s.key] || [];
        const img =
          state === "current" ? images.current : state === "done" ? images.done : images.todo;

        return (
          <div className={s.cls} key={s.key}>
            <button
              type="button"
              className="step-jump"
              onClick={() => onJump && onJump(s.key)}
              aria-current={state === "current" ? "step" : undefined}
              title={`Go to step ${s.num} — ${s.label}`}
            >
              <img src={img} alt="" />
              <p className="inter f-14 font-weight-bold mb-1">Step {s.num}</p>
              <p className="inter f-14 font-weight-normal">{s.label}</p>
              {problems.length > 0 && (
                <p className="step-verify" title={problems.map((p) => p.message).join("\n")}>
                  Verification needed
                </p>
              )}
            </button>
          </div>
        );
      })}
    </div>
  );
}
